import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ActionKind, ApplyActionSchema } from '@app/models/orders';
import Api from '@app/services/api';
import { getFormErrorsFromResponse } from '@app/services/getFormErrorsFromResponse';

interface IParams {
  order_uid: string;
  kind: ActionKind;
  data: ApplyActionSchema;
}

export const useApplyActionQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);
  const orderT = useTranslation(NSKeys.order);
  const validationT = useTranslation(NSKeys.validation);
  const getSuccessMessage = (kind: ActionKind) => {
    switch (kind) {
      case ActionKind.ApproveOrder:
        return orderT.t('successApprove');
      case ActionKind.MarkAsNeedsWork:
        return orderT.t('successMarkAsNeedWork');
      case ActionKind.ApprovalCancelOrder:
        return orderT.t('successCancel');
      default:
        return '';
    }
  };

  return useMutation({
    mutationFn: async ({ order_uid, data, kind }: IParams) => {
      await Api.orders.applyAction(data, order_uid, kind);
    },
    onSuccess: async (_, { order_uid, kind }) => {
      await client.invalidateQueries(['getOrder', order_uid]);
      message.open({
        type: 'success',
        content: getSuccessMessage(kind),
      });
    },
    onError: (err) => {
      const { formMessages } = getFormErrorsFromResponse({}, err, validationT.t);
      message.open({
        type: 'error',
        content: formMessages[0] || commonT.t('error400'),
      });
    },
  });
};
